import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { clamp } from 'lodash';

export const clampPageNumber = (pageNumber, itemCount, pageSize) =>
  clamp(pageNumber, 0, Math.ceil(itemCount / pageSize) - 1);

// bound the page number to it's maximum possible size and update it.
export const correctPageNumber = ({ onPageChange, page, pageSize, loading }, itemCount) => {
  const clampedPage = clampPageNumber(page, itemCount, pageSize);
  if (page !== clampedPage && !loading) onPageChange(null, clampedPage);
};

// reset the page number to 0.
export const resetPageNumber = ({ onPageChange, page }) => {
  if (page !== 0) onPageChange(null, 0);
};

export function withPagination({ defaultPage = 0, defaultPageSize = 20, tableName: tableNameOnCreation } = {}) {
  return (Component) => {
    function ComponentWithPagination(props) {
      const { searchParameters, tableName, ...rest } = props;
      const storageKey = tableName || tableNameOnCreation || 'default';
      const pageKey = `${storageKey}.page`;
      const pageSizeKey = `${storageKey}.pageSize`;

      const [page, setPage] = useState(parseInt(localStorage.getItem(pageKey), 10) || defaultPage);
      const [pageSize, setPageSize] = useState(parseInt(localStorage.getItem(pageSizeKey), 10) || defaultPageSize);

      const top = pageSize;
      const skip = page * pageSize;

      const onPageChange = (e, newPage) => {
        localStorage.setItem(pageKey, newPage);
        setPage(newPage);
      };

      const onRowsPerPageChange = ({ target: { value: newPageSize } }) => {
        localStorage.setItem(pageSizeKey, newPageSize);
        setPageSize(newPageSize);
      };

      return (
        <Component
          {...rest}
          tableName={tableName}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          searchParameters={{ ...searchParameters, top, skip }}
        />
      );
    }

    ComponentWithPagination.propTypes = {
      searchParameters: PropTypes.shape({}),
      tableName: PropTypes.string
    };

    ComponentWithPagination.defaultProps = {
      searchParameters: {},
      tableName: ''
    };

    return ComponentWithPagination;
  };
}

export const paginationPropTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func
};
withPagination.propTypes = paginationPropTypes;

export const paginationDefaultProps = {
  count: 0,
  page: 0,
  pageSize: 20,
  onPageChange: () => {},
  onRowsPerPageChange: () => {}
};
withPagination.defaultProps = paginationDefaultProps;

export default withPagination;
